import React, { lazy, Suspense } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Loading from "components/shared-components/Loading";
import { APP_PREFIX_PATH } from "configs/AppConfig";

export const AppViews = () => {
  return (
    <Suspense fallback={<Loading cover="content" />}>
      <Switch>
        <Route path={`${APP_PREFIX_PATH}/dashboard`} component={lazy(() => import(`./dashboard`))} />
        <Route path={`${APP_PREFIX_PATH}/users`} component={lazy(() => import(`./users`))} />
        <Route path={`${APP_PREFIX_PATH}/ab-book`} component={lazy(() => import(`./risk`))} />
        <Redirect from={`${APP_PREFIX_PATH}/risk`} to={`${APP_PREFIX_PATH}/ab-book`} />
        <Route path={`${APP_PREFIX_PATH}/financial`} component={lazy(() => import(`./financial`))} />
        <Route path={`${APP_PREFIX_PATH}/partnership`} component={lazy(() => import(`./partnership`))} />
        <Route path={`${APP_PREFIX_PATH}/invest`} component={lazy(() => import(`./invest`))} />
        <Route path={`${APP_PREFIX_PATH}/social-trade`} component={lazy(() => import(`./socialtrade`))} />
        <Route path={`${APP_PREFIX_PATH}/support`} component={lazy(() => import(`./support`))} />
        <Route path={`${APP_PREFIX_PATH}/setting`} component={lazy(() => import(`./setting`))} />
        <Route path={`${APP_PREFIX_PATH}/vps`} component={lazy(() => import(`./vps`))} />
        <Redirect from={`${APP_PREFIX_PATH}`} to={`${APP_PREFIX_PATH}/dashboard`} />
      </Switch>
    </Suspense>
  );
};

export default React.memo(AppViews);
